import Sidebar from 'component/Sidebar/sidebar'
import React from 'react'
import { Outlet } from 'react-router-dom'
import { useTranslation } from 'context/translation'

function AdminLayout() {
  const { isRTL } = useTranslation()
  return (
    <>
      <Sidebar />
      <main className={`md:w-[calc(100vw-329px)] sm:ms-[292px]`}>
        <div className='pt-5 mt-[30px]'>
          <div
            style={{
              borderRadius: '0px 0px 20px 20px ',
              minHeight: 'calc(100vh - 100px)',
            }}
            className='p-4 bg-white'
          >
            <Outlet />
          </div>
        </div>
      </main>
    </>
  )
}

export default AdminLayout
